<template>
  <div>
    <el-table
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      :data="data"
      v-bind="$attrs"
      v-on="listeners"
      style="width: 100%">
      <slot name="columns">
        <el-table-column
          v-for="col in cols"
          :sortable="col.sortable? 'custom': false"
          :prop="col.key"
          :key="col.key || col.prop"
          :label="col.label"
          :width="col.width"
          :align="col.align" :header-align="col.align"
          :render-header="col.info? renderHeader: null">
          <!-- v-bind="col" -->

          <!-- Lazy columns w/o extra formatting -->
          <template slot-scope="{row}">
            <slot :name="col.prop || col.key" :row="row">
              {{row[col.key]}}
            </slot>
          </template>

        </el-table-column>
      </slot>
    </el-table>

    <!-- Footer setup -->
    <div class="row d-flex">
      <div class="col-12 col-md-6">
        <slot name="pagination" :page="page" :total="total">
          <el-pagination
            v-model="page"
            :page-size="rowsPerPage"
            :total="total"
            @current-change="onPageRequest"
            layout="prev, pager, next">
          </el-pagination>
        </slot>
      </div>

      <div class="col-12 col-md-3">
        {{ $t('DataTable.Per_Page')}}：
        <el-select v-model="rowsPerPage" size="mini" @change="onRowsPerPageChangeListener">
          <el-option v-for="rpp in rowsPerPageOptions"
            :key="rpp" :label="rpp" :value="rpp">
          </el-option>
        </el-select>
      </div>

      <div class="col-12 col-md-3">
        {{ $t('DataTable.Total_Count')}}：<b>{{total}}</b>
      </div>
    </div>
    
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Pagination
} from 'element-ui';

export default {
  name: 'DataTable',
  inheritAttrs: false,
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  props: {
    cols: Array,
    data: Array,
    total: Number,
    rowsPerPageOptions: Array, // Array of row-count numbers.
    onSortChange: Function,
    onPageRequest: Function,
    onRowsPerPageChange: Function,
    loading: Boolean
  },
  data() {
    return {
      page: 1,
      rowsPerPage: this.rowsPerPageOptions[0] // In default
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        ['sort-change']: this.onSortChangeListener
      };
    }
  },
  methods: {
    async getTableData(page) {
      // console.warn(`DataTable: Trying to fetch page ${page}...`);
    },

    onSortChangeListener({prop, key, order}) {
      this.onSortChange({prop, key, order});
    },
    onRowsPerPageChangeListener(val) {
      this.onRowsPerPageChange(val);
    },

    renderHeader(h, {column, $index}) {
      let tooltipInfo = this.cols[$index].info;
      return h(
        'el-tooltip',
        {
          props: {
            content: (() => {
              return tooltipInfo || '';
            })(),
            placement: 'top'
          },
          domProps: {
            innerHTML: column.label + (tooltipInfo? '<span class="el-icon-question"></span>': '')
          }
        },
        [h('span')]//WARNING: ???
      );
    }

  },
  created() {
    console.info('DataTable: created');
  }
};
</script>

<style scoped>
/* So that text and carets in <th> align each other */
th div.cell {
  -webkit-box-align: center !important;
  align-items: center !important;
  min-height: 34px;
  line-height: 34px;
}
</style>